import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from '@app/common/services/dialog.service';
import { ProjectSubjectModel } from '@app/ps/models/project-subject.model';
import { LesseeEditComponent } from '@app/ps/components/lessee-edit/lessee-edit.component';
import { Restangular } from 'ngx-restangular';

@Component({
  selector: 'lessee-detail',
  templateUrl: './lessee-detail.component.html',
})
export class LesseeDetailComponent implements OnInit {

  @Input() lesseeId: number;

  loading = true;
  lessee: ProjectSubjectModel;

  constructor(
    private restangular: Restangular,
    private dialogService: DialogService,
  ) {
    this.onEdit = this.onEdit.bind(this);
  }

  ngOnInit() {
    this.restangular
      .one('lessees', this.lesseeId)
      .get({ loadCollections: [ 'actingPersons' ] })
      .toPromise()
      .then(data => {
        this.lessee = data.plain();
        this.loading = false;
      });
  }

  onEdit() {
    const dialog = this.dialogService.open(LesseeEditComponent, {
      data: { lesseeId: this.lessee.id }
    });

    const sub = dialog.afterClosed.subscribe((res: ProjectSubjectModel) => {
      if (res) {
        Object.assign(this.lessee, res);
      }
      sub.unsubscribe();
    });
  }
}
